import {
  SOCKET_CONNECTION_UNKNOWN,
  SOCKET_CONNECTION_CONNECT,
  SOCKET_CONNECTION_DISCONNECT,
  SOCKET_CONNECTION_RECONNECT,
} from '../constants/ActionTypes';

export const socketUnknown = () => (dispatch) => {
  dispatch({
    type: SOCKET_CONNECTION_UNKNOWN,
    data: {},
  });

  return Promise.resolve();
};

export const socketConnect = () => (dispatch) => {
  dispatch({
    type: SOCKET_CONNECTION_CONNECT,
    data: {},
  });

  return Promise.resolve();
};

export const socketReconnect = () => (dispatch) => {
  dispatch({
    type: SOCKET_CONNECTION_RECONNECT,
    data: {},
  });

  return Promise.resolve();
};

export const socketDisconnect = (data) => (dispatch) => {
  dispatch({
    type: SOCKET_CONNECTION_DISCONNECT,
    data,
  });

  return Promise.resolve();
};
